import { ColumnDef } from "@tanstack/react-table";
import { LineClampedTooltip } from "@volca/ui/components/ui/line-clamped-tooltip";

type Technician = {
  display_identification?: string;
  first_name: string | null;
  last_name: string | null;
};

type AttributionRow = {
  technicians: Technician[] | null;
};

export const AttributionCol = <
  T extends AttributionRow = AttributionRow,
>(): ColumnDef<T> => ({
  header: "Attribution",
  accessorFn: (row) => {
    const technicians = row.technicians;
    if (!technicians || technicians.length === 0) return "";

    return technicians
      .map((t) => t.display_identification)
      .filter(Boolean)
      .join(" ")
      .trim()
      .toLowerCase();
  },
  accessorKey: "technicians",
  sortingFn: (rowA, rowB) => {
    const techsA = rowA.original.technicians?.length || 0;
    const techsB = rowB.original.technicians?.length || 0;
    return techsA - techsB;
  },
  cell: ({ row }) => {
    const technicians = row.original.technicians;
    if (!technicians || technicians.length === 0) return "–";

    if (technicians.length <= 2) {
      const names = technicians
        .map((t) => t.display_identification)
        .filter(Boolean)
        .join(", ");
      return <LineClampedTooltip>{names}</LineClampedTooltip>;
    }

    return `${technicians.length} technicians`;
  },
});
